import React from 'react';
import HrcsEditor from './HrcsEditor';
import {
    BrowserRouter,
    Route,
    NavLink
} from 'react-router-dom';
import HomePage from './HomePage';
import FaqPage from './FaqPage';
import StyleGuidePage from './StyleGuidePage';

export default class App extends React.PureComponent {
    render() {
        return (
            <BrowserRouter>
                <div className="app">
                    <header className="app-header">
                        <div className="app-header-inner content">
                            <a className="app-header-link" href="/"><img className="app-header-logo" alt="Logo" src="/images/logo.svg" /> <span> Ressursside HRCS</span></a>
                            <span className="app-header-text">Verktøy, instruksjoner og veiledninger</span>
                        </div>
                    </header>
                    <nav className="app-menu">
                        <div className="content">
                            <NavLink to="/" exact={true} className="app-menu-link">Introduksjon</NavLink>
                            <NavLink to="/editor" className="app-menu-link">Registrering</NavLink>
                            <a className="app-menu-link" href="https://www.helseomsorg21monitor.no/">HelseOmsorg21-monitor</a>
                        </div>
                    </nav>
                    <main className="app-content">
                        <Route path="/" exact={true} component={HomePage}/>
                        <Route path="/editor" component={HrcsEditor}/>
                        <Route path="/styleguide" component={StyleGuidePage} />
                        <Route path="/faq" component={FaqPage} />
                    </main>
                    <footer className="app-footer">
                        <div className="app-footer-menu">
                            <div className="content">
                                <h2 id="kontaktpersoner">Kontaktpersoner</h2>
                                <ul className="app-footer-menu">
                                    <li><a href="mailto:dhe@rcn.no">Dyveke Hetland (dhe@rcn.no)</a></li>
                                    <li><a href="mailto:man@rcn.no">Mari K. Nes (man@rcn.no)</a></li>
                                    <li>Send oss en e-post, hvis du lurer på noe når du skal klassifisere med HRCS.</li>
                                </ul>
                            </div>
                        </div>
                        <div className="app-footer-copyright">
                            HelseOmsorg21-monitor © {new Date().getFullYear()} Forskningsrådet.
                        </div>
                    </footer>
                </div>
            </BrowserRouter>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js